import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { HourlyTuitionDiscountType } from './hourly-tuition.constants';

export interface UpdateDraftRequest {
  discountType: HourlyTuitionDiscountType;
  discount: number;
}

export interface UpdateDraftResponse {
  success: boolean;
  message: string;
}

// Update draft API
export const updateDraftAPI = async (
  draftId: string,
  data: UpdateDraftRequest,
): Promise<UpdateDraftResponse> => {
  const response = await baseAPI.patch(
    `/hourly-tuition-billing/draft/${draftId}`,
    data,
  );
  return response.data;
};

// React Query hook
export const useUpdateDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      draftId,
      data,
    }: {
      draftId: string;
      data: UpdateDraftRequest;
    }) => updateDraftAPI(draftId, data),
    onSuccess: () => {
      // Invalidate all session billing breakdown queries to refresh data
      queryClient.invalidateQueries({
        predicate: (query) => {
          return (
            query.queryKey[0] === KEYS.HOURLY_TUITION_BILLING &&
            query.queryKey[1] === KEYS.SESSION_BILLING_BREAKDOWN
          );
        },
      });
    },
  });
};
